import client from './client';

export interface AQIReading {
  id: number;
  station_name?: string;
  aqi: number;
  pm25?: number;
  pm10?: number;
  temperature?: number;
  humidity?: number;
  measured_at: string;
}

export interface EcologyAlert {
  id: number;
  alert_type: string;
  aqi_value?: number;
  message_kk?: string;
  message_ru?: string;
  created_at: string;
}

export const ecologyApi = {
  getLatest: () =>
    client.get<AQIReading>('/api/v1/ecology/aqi'),

  getHistory: (params?: { days?: number }) =>
    client.get<AQIReading[]>('/api/v1/ecology/aqi/history', { params }),

  getAlerts: () =>
    client.get<EcologyAlert[]>('/api/v1/ecology/alerts'),
};
